import { Injectable } from '@angular/core';
import { IAttachmentSource } from 'attachment-source-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';
import { ISourceOption } from '../../../../../services/attachment-source-options/iattachment-source-option-label.service';
import { ServiceProviderServiceFactory } from '../../../../../services/service-providers/service-provider-service.factory';

export { ISourceOption } from '../../../../../services/attachment-source-options/iattachment-source-option-label.service';

@Injectable({ providedIn: 'root' })
export class AttachmentSourceOptionService {
  private attachmentSourceService: IAttachmentSource;

  constructor(
    private identityStorage: IdentityStorage,
    private serviceProviderServiceFactory: ServiceProviderServiceFactory,
    private sharedProviderServiceFactory: SharedServiceProviderServiceFactory,
  ) {
    this.attachmentSourceService = sharedProviderServiceFactory
      .getServiceProviderService(this.identityStorage.get().namespace)
      .getAttachmentSourceService();
  }

  getDefaultOption(entity: string): Observable<ISourceOption> {
    return this.getOption(this.attachmentSourceService.getDefault(entity));
  }

  getOption(optionPaths: string): Observable<ISourceOption> {
    return this.getOptions([optionPaths]).pipe(map((array) => array[0]));
  }

  getOptions(optionPaths: string[]): Observable<ISourceOption[]> {
    const namespace = this.identityStorage.get().namespace;
    return this.serviceProviderServiceFactory
      .getServiceProviderService(namespace)
      .getAttachmentSourceOptionLabelService()
      .getOptions(optionPaths);
  }

  getAvailableEntitiesForSource(templateEntity: string): Observable<string[]> {
    const namespace = this.identityStorage.get().namespace;
    return this.sharedProviderServiceFactory.getServiceProviderService(namespace).getAttachmentSourceService().getOptions(templateEntity);
  }
}
